import SendConfigInfoDialog from './sendConfigInfoDialog';
export default SendConfigInfoDialog;